/**
 * @file 字典管理路由配置
 * @description 用于定义字典管理相关的路由配置，包括创建字典、编辑字典、删除字典、查看字典详情等。
 */

const dictionary = [
  {
    path: '/dictionary/manage',
    name: 'DictionaryCreateView',
    component: () => import('@/view/dictionary/DictionaryManageView.vue')
  },
  {
    path: '/dictionary/data',
    name: 'DictionaryDataView',
    component: () => import('@/view/dictionary/DictionaryDataView.vue'),
  }
]
export default dictionary
